import React, { useState } from "react";
import { motion, } from "framer-motion";
import marketingimg from "../../../../../images/LandingPageImage/mn_logistic.webp";
import ecommerce from "../../../../../images/LandingPageImage/mn_e_commerce.webp"
import healthcare from "../../../../../images/LandingPageImage/mn_healthcare.webp";
import travel from "../../../../../images/LandingPageImage/mn_travel.webp";
import education from "../../../../../images/LandingPageImage/mn_education.webp";
import '../../styles/LandingPageCss/Industries.css'



const tabs = [
    {
        title: "Education",
        desc: "Message Notifier transforms how educational institutions communicate with students, parents, and staff by enabling instant, personalized messaging through WhatsApp.",
        image: education,
        bgColor: "bg-titan"
    },
    {
        title: "Logistics",
        desc: "We helps logistics companies streamline communication with clients, drivers, and partners through instant and automated messaging.",
        image: marketingimg,
        bgColor: "bg-cream"
    },
    {
        title: "E-Commerce",
        desc: "We helps e‑commerce businesses boost sales and improve customer service by sending automated WhatsApp messages for order confirmations, delivery updates, and abandoned cart reminders. ",
        image: ecommerce,
        bgColor: "bg-chalk"
    },
    {
        title: "Healthcare",
        desc: "We helps healthcare providers enhance patient communication by sending automated appointment reminders, prescription alerts, and follow‑up messages via WhatsApp. ",
        image: healthcare,
        bgColor: "bg-dandelion"
    },
    {
        title: "Travel",
        desc: "We helps travel businesses keep customers informed with instant WhatsApp updates on bookings, itinerary changes, and travel reminders. ",
        image: travel,
        bgColor: "bg-solitude"
    }
    
];




export default function Industries() {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="bg-light py-5 py-md-6 py-lg-7 font-sans px-3 px-md-4">
            <header className="text-center container mb-4 mb-md-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        <h2 className="new-section-title mb-3 mb-md-4">
                            Scalable Solutions to all <br className="d-none d-sm-block" />
                            Businesses
                        </h2>
                        <p className="new-section-subtitle ">
                            Message Notifier is designed to accommodate any businesses in all levels of development. The platform is flexible to your requirements whether you are a startup with a small number of customers or a business with large volumes of conversations.
                        </p>
                    </div>
                </div>
            </header>

          
            <div className="container">
                <div className="row justify-content-center g-4 g-md-5 py-4 py-md-5">
                    
                    <div className="d-none d-lg-flex col-lg-6 align-items-center justify-content-center">
                        <motion.img
                            key={activeIndex}
                            src={tabs[activeIndex].image}
                            alt={tabs[activeIndex].title}
                            className="img-fluid w-100"
                            style={{ maxWidth: "500px" }}
                            initial={{ opacity: 0, scale: 0.85 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.4, ease: "easeOut" }}
                        />
                    </div>

                   
                    <div className="col-12 col-lg-6">
                        <div className="accordion " id="industriesAccordion">
                            {tabs.map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`accordion-item  mb-2 rounded-3 ${activeIndex === idx ? 'active' : ''}`}
                                >
                                    <div
                                        className={`accordion-header  ${activeIndex === idx ? item.bgColor : 'bg-white'}  rounded-3 p-3 p-md-4`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setActiveIndex(idx)}
                                    >
                                        <h3 className="font-spacegrotesk fs-5 fs-md-3 fw-semibold mb-1 mb-md-2">
                                            {item.title}
                                        </h3>
                                        <p className="text-dark mb-0 fs-6 fs-md-6">
                                            {item.desc}
                                        </p>

                                        
                                        <div className="d-lg-none mt-3 mt-md-4">
                                            {activeIndex === idx && (
                                                <motion.img
                                                    key={idx}
                                                    src={item.image}
                                                    alt={item.title}
                                                    className="img-fluid rounded-3"
                                                    style={{ maxWidth: "200px", margin: "0 auto" }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    transition={{ duration: 0.4, ease: "easeOut" }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
